
// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import "../../css/common.css";
// import { Box, Typography } from "@mui/material";
// import { BarChart, LineChart, PieChart, ScatterChart } from "@mui/x-charts";
// import { Card, Row } from "antd";
// import { post } from "../../../services/services";
// import { ApiURL, baseURL } from "../../../services/apiConstants";
// import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
// import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
// import ShipComparisonChartSelector from "./components/ShipComparisonChartSelector";
 
// const { Meta } = Card;
 
// function ShipComparisonPage() {
//   const navigate = useNavigate();
//   const [selectedDates, setSelectedDates] = useState(null);
//   const [engineType, setEngineType] = useState([]);
//   const [selectedChart, setSelectedChart] = useState("bar");
//   const [selectedParameters, setSelectedParameters] = useState([]);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [series, setSeries] = useState([]);
//   const [xAxis, setXAxis] = useState([]);
//   const [shipTableList, setShipTableList] = useState([]);
//   const [shipIds, setShipIds] = useState([]);
//   const [shipDetailsList, setShipDetailsList] = useState([]);
//   const [timeFormat, setTimeFormat] = useState("daily");
//   const [engineOptions, setEngineOptions] = useState([]);
//   const [parameterOptions, setParameterOptions] = useState({});
//   const [selectedLogbook, setSelectedLogbook] = useState(["engine_logbook"]);
 
//   /** ----------------- API HANDLERS ----------------- **/
//   const fetchShipDetailsList = useCallback(async () => {
//     try {
//       const res = await post(ApiURL.dashboard_ship_details_com, new FormData());
//       if (res?.status) setShipDetailsList(res.ship_list || []);
//     } catch (error) {
//       console.error("Error fetching ship list:", error);
//     }
//   }, []);
 
//   const fetchShipTableList = useCallback(async () => {
//     try {
//       const res = await post(ApiURL.list_ships_view_com, new FormData());
//       if (res?.status && res.ships?.length) {
//         // ✅ Just set ship list, don’t reset shipIds
//         setShipTableList(res.ships);
//       }
//     } catch (error) {
//       console.error("Error fetching ship table list:", error);
//     }
//   }, []);


 
// const fetchGraphData = useCallback(async () => {
//   if (!startDate || !endDate || !shipIds?.length || !selectedParameters?.length)
//     return;

//   try {
//     // ✅ Build request payload
//     const shipsPayload = shipIds.map((shipId) => {
//       const shipMachines = selectedParameters
//         .filter((p) => String(p.shipId) === String(shipId))
//         .map((p) => ({
//           value: p.value,
//           type: p.type,
//         }));

//       return {
//         ship_id: shipId,
//         log_books: selectedLogbook,
//         machines: shipMachines,
//       };
//     });

//     const formData = new FormData();
//     formData.append("start_date", startDate);
//     formData.append("end_date", endDate);
//     formData.append("ships", JSON.stringify(shipsPayload));

//     // ✅ Call API
//     const res = await post(ApiURL.multiple_company_get_grap_data_com, formData);

//     if (res?.status) {
//       SuccessToast("Success!", res?.message);

//       /** 🧩 STEP 1: Gather all unique X-axis dates from all ships */
//       let allDates = [];
//       Object.values(res.data || {}).forEach((shipData) => {
//         if (shipData.xAxis?.[0]?.data?.length) {
//           allDates.push(...shipData.xAxis[0].data);
//         }
//       });

//       // Remove duplicates + sort by date
//       const uniqueDates = [...new Set(allDates)].sort(
//         (a, b) => new Date(a) - new Date(b)
//       );

//       /** 🧩 STEP 2: Align each ship’s series with this master X-axis */
//       const alignedSeries = [];

//       Object.entries(res.data || {}).forEach(([shipId, shipData]) => {
//         const shipName =
//           shipTableList.find((s) => s.id == shipId)?.vessel_name ||
//           `Ship ${shipId}`;
//         const shipDates = shipData.xAxis?.[0]?.data || [];

//         shipData.series.forEach((serie) => {
//           // Align each data point with global X-axis
//           const alignedData = uniqueDates.map((date) => {
//             const idx = shipDates.indexOf(date);
//             // 👇 Use null to skip drawing points, or 0 if you want visible zeros
//             return idx !== -1 ? serie.data[idx] : null;
//           });

//           alignedSeries.push({
//             ...serie,
//             data: alignedData,
//             label: `${shipName} - ${serie.label}`,
//           });
//         });
//       });

//       /** 🧩 STEP 3: Update state for chart rendering */
//       setXAxis([{ data: uniqueDates, scaleType: "band" }]);
//       setSeries(alignedSeries);
//     } else {
//       ErrorToast("Error Message", res?.message || "Failed to fetch graph data");
//     }
//   } catch (error) {
//     console.error("API call error:", error);
//   }
// }, [startDate, endDate, selectedParameters, selectedLogbook, shipIds, shipTableList]);

//   const fetchEngineOptions = useCallback(
//     async (shipIds) => {
//       if (!shipIds || shipIds.length === 0) return;
//       try {
//         const formData = new FormData();
//         formData.append("ship_ids", JSON.stringify(shipIds));
 
//         const res = await post(ApiURL.all_machinary_on_multiple_ship_com, formData);
//         if (res?.status) {
//           const grouped = Object.entries(res.data || {}).map(([shipId, categories]) => ({
//             shipId,
//             shipName:
//               shipTableList.find((s) => s.id == shipId)?.vessel_name ||
//               `Ship ${shipId}`,
//             options: Object.values(categories)
//               .flat()
//               .map((item) => ({
//                 value: item.type,
//                 label: item.name,
//               })),
//           }));
//           setEngineOptions(grouped);
//         } else {
//           ErrorToast("Error Message", "Failed to fetch engine options");
//         }
//       } catch (error) {
//         console.error("Error fetching engine options:", error);
//       }
//     },
//     [shipTableList]
//   );
 
//   const fetchParameterOptions = useCallback(() => {
//     if (!shipIds?.length) return;
 
//     const formData = new FormData();
//     formData.append("ship_ids", JSON.stringify(shipIds));
 
//     let mergedTypes = [...selectedLogbook];
//     if (selectedLogbook.includes("engine_logbook") && engineType?.length) {
//       mergedTypes.push(...engineType);
//     }
 
//     const filteredTypes = [...new Set(mergedTypes.filter(Boolean))];
//     if (!filteredTypes.length) return;
 
//     formData.append("types", JSON.stringify(filteredTypes));
 
//     post(ApiURL.multiple_machine_fields_graph_com, formData).then((res) => {
//       if (res?.status) {
//         setParameterOptions(res.data || {});
//       } else {
//         ErrorToast("Error", res.error || "Failed to fetch parameters");
//       }
//     });
//   }, [JSON.stringify(shipIds), JSON.stringify(engineType), JSON.stringify(selectedLogbook)]);
 
//   /** ----------------- EFFECTS ----------------- **/
//   useEffect(() => {
//     fetchShipDetailsList();
//     fetchShipTableList();
//   }, []);
 
//   useEffect(() => {
//     if (shipIds.length > 0) {
//       const timeout = setTimeout(() => fetchEngineOptions(shipIds), 300);
//       return () => clearTimeout(timeout);
//     }
//   }, [shipIds, fetchEngineOptions]);
 
//   useEffect(() => {
//     if (selectedLogbook?.length > 0 && shipIds?.length > 0) {
//       fetchParameterOptions();
//     }
//   }, [JSON.stringify(selectedLogbook), JSON.stringify(engineType), JSON.stringify(shipIds)]);
 
//   /** ----------------- DATA TRANSFORM ----------------- **/
//   const transformDataByFormat = (rawXAxis, rawSeries, format) => {
//     if (!rawXAxis?.[0]?.data || !rawSeries?.length)
//       return { xAxis: [], series: [] };
 
//     const parsedDates = rawXAxis[0].data.map((d) => dayjs(d));
//     let groups = {};
 
//     parsedDates.forEach((date, idx) => {
//       let key =
//         format === "weekly"
//           ? `${date.year()}-W${date.isoWeek()}`
//           : format === "monthly"
//           ? date.format("YYYY-MM")
//           : date.format("YYYY-MM-DD");
//       if (!groups[key]) groups[key] = [];
//       groups[key].push(idx);
//     });
 
//     const newXAxis = Object.keys(groups);
//     const newSeries = rawSeries.map((serie) => ({
//       ...serie,
//       data: newXAxis.map((group) => {
//         const indices = groups[group];
//         const values = indices.map((i) => serie.data[i] || 0);
//         return values.length
//           ? values.reduce((a, b) => a + b, 0) / values.length
//           : 0;
//       }),
//     }));
 
//     return {
//       xAxis: [{ scaleType: "band", data: newXAxis }],
//       series: newSeries,
//     };
//   };
 
//   const { xAxis: transformedXAxis, series: transformedSeries } = useMemo(
//     () => transformDataByFormat(xAxis, series, timeFormat),
//     [xAxis, series, timeFormat]
//   );
 
//   const pieChartData = useMemo(
//     () =>
//       transformedSeries.map((item, index) => ({
//         id: index,
//         value: item.data.reduce((a, b) => a + b, 0),
//         label: item.label,
//       })),
//     [transformedSeries]
//   );
 
//   const scatterSeries = useMemo(
//     () =>
//       transformedSeries.map((item) => ({
//         label: item.label,
//         color: item.color,
//         data: item.data.map((value, index) => ({ x: index, y: value })),
//       })),
//     [transformedSeries]
//   );
 
//   /** ----------------- RENDER ----------------- **/
//   return (
//     <>
//       <div className="white-container">
//         <Box sx={{ padding: 1, flex: 1 }}>
//           <ShipComparisonChartSelector
//             selectedDates={selectedDates}
//             setSelectedDates={setSelectedDates}
//             engineType={engineType}
//             setEngineType={setEngineType}
//             selectedChart={selectedChart}
//             setSelectedChart={setSelectedChart}
//             selectedParameters={selectedParameters}
//             setSelectedParameters={setSelectedParameters}
//             ship_table_list={shipTableList}
//             set_ship_ids={setShipIds}
//             ship_ids={shipIds}
//             setStartDate={setStartDate}
//             setEndDate={setEndDate}
//             startDate={startDate}
//             endDate={endDate}
//             Graph_data={fetchGraphData}
//             timeFormat={timeFormat}
//             setTimeFormat={setTimeFormat}
//             engineOptions={engineOptions}
//             parameterMappings={parameterOptions}
//             setSelectedLogbook={setSelectedLogbook}
//             selectedLogbook={selectedLogbook}
//           />
 
//           <Box
//             sx={{
//               width: "100%",
//               height: "480px",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               marginTop: 3,
//             }}
//           >
//             <Typography variant="h6" align="center" gutterBottom>
//               {selectedChart} Chart ({timeFormat})
//             </Typography>
 
//             {selectedChart === "bar" && (
//               <BarChart
//                 height={410}
//                 margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
//                 series={transformedSeries}
//                 xAxis={transformedXAxis}
//                 slotProps={{ legend: { hidden: true } }}
//               />
//             )}
//             {selectedChart === "line" && (
//               <LineChart
//                 height={410}
//                 margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
//                 series={transformedSeries}
//                 xAxis={transformedXAxis}
//                 slotProps={{ legend: { hidden: true } }}
//               />
//             )}
//             {selectedChart === "pie" && (
//               <PieChart
//                 height={410}
//                 margin={{ top: 50, bottom: 30, left: -70 }}
//                 series={[{ data: pieChartData }]}
//                 slotProps={{ legend: { hidden: true } }}
//               />
//             )}
//             {selectedChart === "scatter" && (
//               <ScatterChart
//                 height={410}
//                 margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
//                 series={scatterSeries}
//                 slotProps={{ legend: { hidden: true } }}
//               />
//             )}
//           </Box>
//         </Box>
//       </div>
//     </>
//   );
// }
 
// export default ShipComparisonPage;
 




import React, { useEffect, useState, useMemo, useCallback } from "react";
import "../../css/common.css";
import { Box, Typography } from "@mui/material";
import { BarChart, LineChart, PieChart, ScatterChart } from "@mui/x-charts";
import { Card, Row } from "antd";
import { post } from "../../../services/services";
import { ApiURL, baseURL } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import ShipComparisonChartSelector from "./components/ShipComparisonChartSelector";

const { Meta } = Card;

function ShipComparisonPage() {
  const navigate = useNavigate();
  const [selectedDates, setSelectedDates] = useState(null);
  const [engineType, setEngineType] = useState([]);
  const [selectedChart, setSelectedChart] = useState("bar");
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [series, setSeries] = useState([]);
  const [xAxis, setXAxis] = useState([]);
  const [shipTableList, setShipTableList] = useState([]);
  const [shipIds, setShipIds] = useState([]);
  const [shipDetailsList, setShipDetailsList] = useState([]);
  const [timeFormat, setTimeFormat] = useState("daily");
  const [engineOptions, setEngineOptions] = useState([]);
  const [parameterOptions, setParameterOptions] = useState({});
  const [selectedLogbook, setSelectedLogbook] = useState(["engine_logbook"]);

  // console.log("parameterOptions ************", parameterOptions);

  /** ----------------- API HANDLERS ----------------- **/
  const fetchShipDetailsList = useCallback(async () => {
    try {
      const res = await post(ApiURL.dashboard_ship_details_com, new FormData());
      if (res?.status) setShipDetailsList(res.ship_list || []);
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  }, []);

  const fetchShipTableList = useCallback(async () => {
    try {
      const res = await post(ApiURL.list_ships_view_com, new FormData());
      if (res?.status && res.ships?.length) {
        // ✅ Just set ship list, don’t reset shipIds
        setShipTableList(res.ships);
      }
    } catch (error) {
      console.error("Error fetching ship table list:", error);
    }
  }, []);


  const fetchGraphData = useCallback(async () => {
    if (
      !startDate ||
      !endDate ||
      !shipIds?.length ||
      !selectedParameters?.length
    )
      return;

    try {
      // ✅ Build request payload
      const shipsPayload = shipIds.map((shipId) => {
        const shipMachines = selectedParameters
          .filter((p) => String(p.shipId) === String(shipId))
          .map((p) => ({
            value: p.value,
            type: p.type,
          }));

        return {
          ship_id: shipId,
          log_books: selectedLogbook,
          machines: shipMachines,
        };
      });

      const formData = new FormData();
      formData.append("start_date", startDate);
      formData.append("end_date", endDate);
      formData.append("ships", JSON.stringify(shipsPayload));

      // ✅ Call API
      const res = await post(
        ApiURL.multiple_company_get_grap_data_com,
        formData
      );

      if (res?.status) {
        SuccessToast("Success!", res?.message);

        /** 🧩 STEP 1: Gather all unique X-axis dates from all ships */
        let allDates = [];
        Object.values(res.data || {}).forEach((shipData) => {
          if (shipData.xAxis?.[0]?.data?.length) {
            allDates.push(...shipData.xAxis[0].data);
          }
        });

        // Remove duplicates + sort by date
        const uniqueDates = [...new Set(allDates)].sort(
          (a, b) => new Date(a) - new Date(b)
        );

        /** 🧩 STEP 2: Align each ship’s series with this master X-axis */
        const alignedSeries = [];

        Object.entries(res.data || {}).forEach(([shipId, shipData]) => {
          const shipName =
            shipTableList.find((s) => s.id == shipId)?.vessel_name ||
            `Ship ${shipId}`;
          const shipDates = shipData.xAxis?.[0]?.data || [];

          shipData.series.forEach((serie) => {
            // Align each data point with global X-axis
            const alignedData = uniqueDates.map((date) => {
              const idx = shipDates.indexOf(date);
              // 👇 Use null to skip drawing points, or 0 if you want visible zeros
              return idx !== -1 ? serie.data[idx] : null;
            });

            alignedSeries.push({
              ...serie,
              data: alignedData,
              label: `${shipName} - ${serie.label}`,
            });
          });
        });

        /** 🧩 STEP 3: Update state for chart rendering */
        setXAxis([{ data: uniqueDates, scaleType: "band" }]);
        setSeries(alignedSeries);
      } else {
        ErrorToast(
          "Error Message",
          res?.message || "Failed to fetch graph data"
        );
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  }, [
    startDate,
    endDate,
    selectedParameters,
    selectedLogbook,
    shipIds,
    shipTableList,
  ]);

  const fetchEngineOptions = useCallback(
    async (shipIds) => {
      if (!shipIds || shipIds.length === 0) return;
      try {
        const formData = new FormData();
        formData.append("ship_ids", JSON.stringify(shipIds));

        const res = await post(
          ApiURL.all_machinary_on_multiple_ship_com,
          formData
        );
        if (res?.status) {
          const grouped = Object.entries(res.data || {}).map(
            ([shipId, categories]) => ({
              shipId,
              shipName:
                shipTableList.find((s) => s.id == shipId)?.vessel_name ||
                `Ship ${shipId}`,
              options: Object.values(categories)
                .flat()
                .map((item) => ({
                  value: item.type,
                  label: item.name,
                })),
            })
          );
          setEngineOptions(grouped);
        } else {
          ErrorToast("Error Message", "Failed to fetch engine options");
        }
      } catch (error) {
        console.error("Error fetching engine options:", error);
      }
    },
    [shipTableList]
  );



  const convertParameterResponse = (responseArray) => {
    const formatted = {};

    responseArray.forEach((item) => {
      const shipId = item.ship_id;
      const group = item.log_books?.[0] || "other"; // Example: "engine_logbook"

      if (!formatted[shipId]) {
        formatted[shipId] = {};
      }

      formatted[shipId][group] = item.machines.map((m) => ({
        value: m.value,
        // label: m.value.replace(/_/g, " ").toUpperCase(), 
        label: m.value.replace(/_/g, " "),
        type: m.type || group,
      }));
    });

    return formatted;
  };

  
  const fetchParameterOptions = useCallback(() => {
    if (!shipIds?.length) return;
    if (!selectedLogbook?.length) return;

    const formData = new FormData();
    formData.append("ship_ids", JSON.stringify(shipIds));

    let mergedTypes = [...selectedLogbook];

    // Add engine types only if engine_logbook is selected
    if (
      selectedLogbook.includes("engine_logbook") &&
      Array.isArray(engineType) &&
      engineType.length
    ) {
      mergedTypes.push(...engineType);
    }

    const filteredTypes = [...new Set(mergedTypes.filter(Boolean))];
    if (!filteredTypes.length) return;

    formData.append("types", JSON.stringify(filteredTypes));

    post(ApiURL.multiple_machine_fields_graph_com, formData)
      .then((res) => {
        if (res?.status) {
          const formatted = convertParameterResponse(res.data);
          setParameterOptions(formatted);
        } else {
          ErrorToast("Error", res.error || "Failed to fetch parameters");
        }
      })
      .catch(() => {
        ErrorToast("Error", "Something went wrong!");
      });
  }, [shipIds, selectedLogbook, engineType]);

  /** ----------------- EFFECTS ----------------- **/
  useEffect(() => {
    fetchShipDetailsList();
    fetchShipTableList();
  }, []);

  useEffect(() => {
    if (shipIds.length > 0) {
      const timeout = setTimeout(() => fetchEngineOptions(shipIds), 300);
      return () => clearTimeout(timeout);
    }
  }, [shipIds, fetchEngineOptions]);


  useEffect(() => {
    if (shipIds?.length && selectedLogbook?.length) {
      fetchParameterOptions();
    }
  }, [shipIds, selectedLogbook, engineType, fetchParameterOptions]);

  /** ----------------- DATA TRANSFORM ----------------- **/
  const transformDataByFormat = (rawXAxis, rawSeries, format) => {
    if (!rawXAxis?.[0]?.data || !rawSeries?.length)
      return { xAxis: [], series: [] };

    const parsedDates = rawXAxis[0].data.map((d) => dayjs(d));
    let groups = {};

    parsedDates.forEach((date, idx) => {
      let key =
        format === "weekly"
          ? `${date.year()}-W${date.isoWeek()}`
          : format === "monthly"
          ? date.format("YYYY-MM")
          : date.format("YYYY-MM-DD");
      if (!groups[key]) groups[key] = [];
      groups[key].push(idx);
    });

    const newXAxis = Object.keys(groups);
    const newSeries = rawSeries.map((serie) => ({
      ...serie,
      data: newXAxis.map((group) => {
        const indices = groups[group];
        const values = indices.map((i) => serie.data[i] || 0);
        return values.length
          ? values.reduce((a, b) => a + b, 0) / values.length
          : 0;
      }),
    }));

    return {
      xAxis: [{ scaleType: "band", data: newXAxis }],
      series: newSeries,
    };
  };

  const { xAxis: transformedXAxis, series: transformedSeries } = useMemo(
    () => transformDataByFormat(xAxis, series, timeFormat),
    [xAxis, series, timeFormat]
  );

  const pieChartData = useMemo(
    () =>
      transformedSeries.map((item, index) => ({
        id: index,
        value: item.data.reduce((a, b) => a + b, 0),
        label: item.label,
      })),
    [transformedSeries]
  );

  const scatterSeries = useMemo(
    () =>
      transformedSeries.map((item) => ({
        label: item.label,
        color: item.color,
        data: item.data.map((value, index) => ({ x: index, y: value })),
      })),
    [transformedSeries]
  );

  /** ----------------- RENDER ----------------- **/
  return (
    <>
      <div className="white-container">
        <Box sx={{ padding: 1, flex: 1 }}>
          <ShipComparisonChartSelector
            selectedDates={selectedDates}
            setSelectedDates={setSelectedDates}
            engineType={engineType}
            setEngineType={setEngineType}
            selectedChart={selectedChart}
            setSelectedChart={setSelectedChart}
            selectedParameters={selectedParameters}
            setSelectedParameters={setSelectedParameters}
            ship_table_list={shipTableList}
            set_ship_ids={setShipIds}
            ship_ids={shipIds}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            startDate={startDate}
            endDate={endDate}
            Graph_data={fetchGraphData}
            timeFormat={timeFormat}
            setTimeFormat={setTimeFormat}
            engineOptions={engineOptions}
            parameterMappings={parameterOptions}
            setSelectedLogbook={setSelectedLogbook}
            selectedLogbook={selectedLogbook}
          />

          <Box
            sx={{
              width: "100%",
              height: "480px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 3,
            }}
          >
            <Typography variant="h6" align="center" gutterBottom>
              {selectedChart} Chart ({timeFormat})
            </Typography>

            {selectedChart === "bar" && (
              <BarChart
                height={410}
                margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
                series={transformedSeries}
                xAxis={transformedXAxis}
                slotProps={{ legend: { hidden: true } }}
              />
            )}
            {selectedChart === "line" && (
              <LineChart
                height={410}
                margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
                series={transformedSeries}
                xAxis={transformedXAxis}
                slotProps={{ legend: { hidden: true } }}
              />
            )}
            {selectedChart === "pie" && (
              <PieChart
                height={410}
                margin={{ top: 50, bottom: 30, left: -70 }}
                series={[{ data: pieChartData }]}
                slotProps={{ legend: { hidden: true } }}
              />
            )}
            {selectedChart === "scatter" && (
              <ScatterChart
                height={410}
                margin={{ top: 80, bottom: 30, left: 40, right: 40 }}
                series={scatterSeries}
                slotProps={{ legend: { hidden: true } }}
              />
            )}
          </Box>
        </Box>
      </div>
    </>
  );
}

export default ShipComparisonPage;
